import { createAgentDot } from './poses/agent';
import { createCursorDot } from './poses/cursor';
import { createEqualizerDot } from './poses/equalizer';
import { createGyreDot } from './poses/gyre';
import { createInfinityDot } from './poses/infinity';
import { createListeningDot } from './poses/listening';
import { createSpeakingDot } from './poses/speaking';
import { createStillDot } from './poses/still';
import { createTwgDot } from './poses/twg';
import type { ConstellationDotColors, ConstellationFrame, ConstellationPose } from './types';

type CreateConstellationFrameInput = Readonly<{
	active: boolean;
	audioGain: number;
	dotColors: ConstellationDotColors;
	pose: ConstellationPose;
	timeSeconds: number;
}>;

// Assigned color for each dot in the constellation
const CONSTELLATION_DOT_COLOR_INDEXES: readonly number[] = [
	0, 3, 2, 1, 3, 2, 1, 3, 2, 1, 0, 3, 2, 1, 0, 3, 2, 1, 0,
];

export const createConstellationFrame = ({
	active,
	audioGain,
	dotColors,
	pose,
	timeSeconds,
}: CreateConstellationFrameInput): ConstellationFrame => {
	return CONSTELLATION_DOT_COLOR_INDEXES.map((colorIndex, index) => {
		const input = {
			color: active ? dotColors.active[colorIndex] : dotColors.inactive,
			index,
			timeSeconds,
		};

		switch (pose) {
			case 'still':
				return createStillDot({ ...input, active });
			case 'listening':
				return createListeningDot({ ...input, audioGain });
			case 'speaking':
				return createSpeakingDot({ ...input, audioGain });
			case 'eq':
				return createEqualizerDot(input);
			case 'twg':
				return createTwgDot(input);
			case 'gyre':
				return createGyreDot(input);
			case 'agent':
				return createAgentDot(input);
			case 'cursor':
				return createCursorDot(input);
			case 'infinity':
				return createInfinityDot(input);
		}
	});
};
